module.exports = __webpack_public_path__ + "static/media/meter-moderately-aggressive.7f2c6809.svg";